const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "code_contains",
      label: "Code",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "surname_contains",
      label: "Surname",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "email_contains",
      label: "Email",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "mobile_contains",
      label: "Phone",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/ClientTypeMultiFilter"),
    props: {
      filterName: "client_type_id_eq",
      label: "Client Type",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/ClientStatusMultiFilter"),
    props: {
      filterName: "client_status_id_eq",
      label: "Client Type",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/clients/clients-filters.js